export interface StepsToTreatmentData {
  description: string
  title?: string
  subtitle?: string
}

export const stepsToTreatment: StepsToTreatmentData[] = [
  {
    subtitle: 'Responda a um breve questionário',
    description: 'Na pré-consulta, você seleciona o profissional desejado para realizar uma consulta.'
  },
  {
    subtitle: 'Faça uma consulta com um(a) especialista',
    description: 'Após escolher a forma de contato e realizar o pagamento, você faz sua consulta com um(a) especialista'
  },
  {
    subtitle: 'Comece seu tratamento personalizado em casa',
    description:
      'Após a consulta, você poderá adquirir seus tratamentos personalizados na Omens ou na farmácia da sua escolha e fazer o tratamento em casa.'
  },
  {
    subtitle: 'Acompanhe e avance seu tratamento',
    description: 'Faça um acompanhamento do seu tratamento e peça ajustes quando necessário.'
  }
]

export const stepsToTreatmentConcise: StepsToTreatmentData[] = [
  {
    description: 'Responda a algumas breves perguntas sobre você e o seu problema. Em alguns casos, pediremos fotos.'
  },
  {
    description: 'Um(a) médico(a) te atenderá por vídeo chamada, telefone ou mensagem e indicará o tratamento.'
  },
  {
    description: 'Você pode encomendar os produtos na própria plataforma Omens ou em farmácias de manipulação'
  }
]

/** /saude-sexual: the concise steps, the 3rd with the pharmacy of your choice (Morgan, 26/10/2026). */
export const stepsToTreatmentSexualHealthConcise: StepsToTreatmentData[] = [
  stepsToTreatmentConcise[0],
  stepsToTreatmentConcise[1],
  {
    description: 'Você pode encomendar os produtos na própria plataforma Omens ou na farmácia da sua escolha'
  }
]

export const menPowerSteps: StepsToTreatmentData[] = [
  {
    title: 'Para quem?',
    description:
      'Entre 15 e 25% dos homens brasileiros podem ser afetados por uma diminuição ou total ausência da libido. 59% dos homens com mais de 40 anos de idade, e 30% dos com menos de 40, enfrentam ou já enfrentaram problemas relacionados à disfunção erétil.'
  },
  {
    title: 'Por que?',
    description:
      'Promover melhorias na saúde sexual masculina, de forma acessível, segura e eficaz, é um dos pilares da Omens.'
  },
  {
    title: 'Como?',
    description:
      'Pautados pelos melhores estudos disponíveis atualmente, nossos médicos desenvolveram o +lib. Para garantir a confiabilidade do produto final, firmamos parcerias com os melhores laboratórios e fornecedores.'
  }
]

export const fertiPlusSteps: StepsToTreatmentData[] = [
  {
    title: 'Para quem?',
    description:
      'No Brasil, a infertilidade é um tema de crescente importância, afetando homens e mulheres em proporções significativas. Estudos indicam que aproximadamente 25% das causas de infertilidade podem ser atribuídas a fatores masculinos, com problemas variados que demandam atenção médica e investigações específicas para cada caso​. O +fert foi desenvolvido para ajudar o homem na sua jornada de fertilidade.'
  },
  {
    title: 'Por que?',
    description:
      'Promover melhorias na saúde reprodutiva de forma acessível, segura e eficaz, é um dos pilares da Omens.'
  },
  {
    title: 'Como?',
    description:
      'Pautados pelos melhores estudos disponíveis atualmente, nossos médicos desenvolveram o +fert. Para garantir a confiabilidade do produto final, firmamos parcerias com os melhores laboratórios e fornecedores.'
  }
]

export const hairPlusSteps: StepsToTreatmentData[] = [
  {
    title: 'Para quem?',
    description:
      'A perda de cabelo é uma condição comum que afeta, só no Brasil, cerca de 42 milhões de pessoas. Ela pode aparecer em qualquer idade, e as causas e formas em que se manifesta variam de pessoa para pessoa. Algumas podem experimentar queda de cabelo temporária, enquanto outras podem ter de uma forma mais permanente.'
  },
  {
    title: 'Por que?',
    description: 'Promover melhorias na saúde capilar, de forma acessível, segura e eficaz, é um dos pilares da Omens.'
  },
  {
    title: 'Como?',
    description:
      'Pautados pelos melhores estudos disponíveis atualmente, nossos médicos desenvolveram o +hair. Para garantir a confiabilidade do produto final, firmamos parcerias com os melhores laboratórios e fornecedores.'
  }
]

export const stepsToTreatmentDermaConcise: StepsToTreatmentData[] = [
  {
    description: 'Responda a algumas breves perguntas sobre você e o seu problema. Em alguns casos, pediremos fotos.'
  },
  {
    description: 'Um(a) médico(a) te atenderá por mensagens e indicará o tratamento.'
  },
  {
    description: 'Você pode encomendar os produtos na própria plataforma Omens ou em farmácias de manipulação.'
  }
]
export const stepsToTreatmentDermaCampaign: StepsToTreatmentData[] = [
  {
    description: 'Responda a algumas breves perguntas sobre você e o seu problema. Em alguns casos, pediremos fotos.'
  },
  {
    description: 'Um(a) médico(a) te atenderá por mensagens e indicará o tratamento.'
  },
  {
    description: 'Você pode encomendar os produtos prescritos na própria plataforma Omens ou onde você preferir!'
  }
]
export const stepsToTreatmentHpb: StepsToTreatmentData[] = [
  {
    subtitle: 'Responda um breve questionário',
    description:
      'Na pré-consulta, você responde um questionário dedicado e escolhe o profissional para realizar uma consulta'
  },
  {
    subtitle: 'Faça uma consulta com um(a) especialista',
    description: 'Após a primeira etapa, você faz sua consulta com o(a) especialista para entender o seu quadro'
  },
  {
    subtitle: 'Receba seu diagnóstico',
    description: 'Receba seus resultados completos com as devidas instruções no conforto de sua casa'
  },
  {
    subtitle: 'Entre com a medicação',
    description: 'Administre a medicação e reduza a sua próstata em até 6 meses sem precisar de cirurgia!'
  }
]

export const stats = [
  {
    title: '2000+',
    description: 'consultas realizadas mensalmente sem sair de casa'
  },
  {
    title: '35.000+',
    description: 'brasileiros escolheram a Omens para cuidar da sua saúde'
  },
  {
    title: '95%',
    description: 'de efetividade nos tratamentos de saúde sexual e dermatologia'
  }
]

export const fertiPlusFactCardsData = [
  {
    title: 'Prepare-se',
    description:
      'Fertilidade é um esporte coletivo. São necessários 23 pares de cromossomos tanto do homem quanto da mulher para criar um bebê. Como você desempenha seu papel? Preparando seus genes para serem os melhores possíveis.'
  },
  {
    title: 'Nutra-se',
    description:
      '+fert nutre o terreno reprodutivo masculino, promovendo um ambiente ideal para o desenvolvimento de esperma vigoroso.'
  },
  {
    title: 'Fortaleça-se',
    description:
      '50% da infertilidade masculina é devido ao estresse oxidativo. Antioxidantes podem proteger as células de esperma e seu valioso carregamento de DNA contra danos induzidos por oxidantes.'
  },
  {
    title: 'Com um produto premium',
    description:
      'Elevando o padrão da saúde reprodutiva. +fert estabelece novos paradigmas, combinando inovação científica e a mais alta qualidade para enriquecer a fertilidade masculina.'
  }
]
